import { motion, useReducedMotion } from "framer-motion";

// Word-by-word mask reveal (Unseen-style). Words rise from behind a mask.
// Renders plainly (fully visible, no motion) for reduced-motion users.
export function KineticText({ text, className = "", as: Tag = "h1", delay = 0, stagger = 0.08, once = true, onMount = false }) {
  const reduce = useReducedMotion();
  if (reduce) return <Tag className={className}>{text}</Tag>;

  const words = text.split(" ");
  const anim = onMount
    ? { animate: { y: "0%" } }
    : { whileInView: { y: "0%" }, viewport: { once, margin: "-40px" } };

  return (
    <Tag className={className}>
      {words.map((word, i) => (
        <span key={i} className="inline-block overflow-hidden align-bottom" style={{ paddingBottom: "0.12em", marginBottom: "-0.12em" }}>
          <motion.span
            className="inline-block"
            initial={{ y: "115%" }}
            {...anim}
            transition={{ duration: 0.85, ease: [0.22, 1, 0.36, 1], delay: delay + i * stagger }}
          >
            {word}
            {i < words.length - 1 ? "\u00A0" : ""}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
}
